/*
  TRAVELAWAY BILDTRIM

  PROBLEMET
  Leverantörernas produktfoton har stora vita marginaler. Uppmätt på ett urval
  fyller motivet 20 till 57 procent av bildytan, och marginalerna är ojämna,
  upp till 33 procent på en enskild sida. I stora visningar gör det inget. I de
  små rutorna, 76 px i bildkolumnen och 48 px i Kombinera med, krymper motivet
  till några få pixlar och resten blir vitt.

  Rutorna saknar dessutom ram, bakgrund och skugga, och sidan är vit, så det
  finns ingen kant som visar var bilden börjar. Resultatet läses som en tom vit
  fyrkant. Upptäckt 19 oktober 2026, gällde hela katalogen.

  LÖSNINGEN
  Originalfilerna rörs inte. I stället mäts motivets kanter i webbläsaren och
  bilden zoomas och centreras med en CSS-transform så motivet fyller rutan.

  VARFÖR INTE BESKÄRA SJÄLVA FILERNA
  Det hade krävt att tusentals bilder laddas ner, beskärs och laddas upp igen.
  Det här ger samma resultat på skärmen, gäller varje ny bild automatiskt, och
  går att slå av genom att ta bort render-raden i travelaway-product-extras.

  TVÅ FEL SOM REDAN ÄR GJORDA, GÖR DEM INTE IGEN
  1. Första versionen tog alla små bilder på sidan och flyttade då också
     sidhuvudets logotyp, som är 350x81 och ritas liten. Därför är urvalet nu
     en uttrycklig lista. Ta aldrig bort avgränsningen.
  2. Selektorn byggdes som BEHALLARE + ' img'. Med en kommalista hängde ' img'
     bara på sista posten, så ingenting trimmades. Bygg alltid per post, som
     BILDVAL nedan gör.

  SÄKERHETSSPÄRRAR
  - Motiv som redan fyller rutan lämnas orörda
  - Livsstilsfoton utan vit bakgrund ger ingen zoom, vilket är rätt beteende
  - Zoomen är takad, så ingen bild blir grynig
  - Avlånga motiv, till exempel en plånbok fotad från sidan, får zooma förbi
    helbild men bara till en viss gräns, annars klipps motivet sönder
  - Bilder från annan domän lämnas orörda, canvas får inte läsa dem
*/
(function () {
  'use strict';

  // Rutor som ska trimmas. Allt annat lämnas i fred.
  var LISTA = [
    '.product__thumb',             // bildkolumnen på produktsidan
    '.tw-komb__media',             // Kombinera med
    '.bundle-product__image-wrap'  // paketblocket
  ];
  var BEHALLARE = LISTA.join(',');
  var BILDVAL = LISTA.map(function (s) { return s + ' img'; }).join(',');

  // Extra spärr även om någon behållare skulle matcha
  var ALDRIG = 'header, footer, .site-header, .site-footer, .logo-bar';

  var MAL = 0.86;        // hur stor andel av rutan motivet ska fylla
  var TAK = 2.6;         // högsta tillåtna zoom
  var EXTRA = 1.6;       // hur långt förbi helbild ett avlångt motiv får zooma
  var MAXRUTA = 140;     // bara rutor upp till den här storleken i px
  var MINFIL = 60;       // hoppa över ikoner och små dekorbilder
  var TROSKEL = 238;     // under det här ljusvärdet räknas en pixel som motiv
  var RUTNAT = 72;       // upplösning på mätningen
  var FYLLD = 0.60;      // över den här andelen anses rutan redan välfylld

  var cache = {};

  function nyckel(src) { return 'twtrim:' + src.split('?')[0]; }

  function lasCache(src) {
    var k = nyckel(src);
    if (cache[k]) return cache[k];
    try {
      var r = sessionStorage.getItem(k);
      if (r) { cache[k] = JSON.parse(r); return cache[k]; }
    } catch (e) {}
    return null;
  }

  function skrivCache(src, v) {
    var k = nyckel(src);
    cache[k] = v;
    try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }

  /*
    Ritar bilden inskriven i en kvadrat och letar upp den minsta rektangel som
    rymmer allt som inte är nästan vitt. Returnerar koordinater 0 till 1 i
    bildens eget koordinatsystem.
  */
  function matMotiv(img) {
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return null;

    var N = RUTNAT;
    var cv = document.createElement('canvas');
    cv.width = N; cv.height = N;
    var ctx = cv.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, N, N);

    var s = Math.min(N / w, N / h);
    var rw = w * s, rh = h * s;
    var ox = (N - rw) / 2, oy = (N - rh) / 2;

    try { ctx.drawImage(img, ox, oy, rw, rh); } catch (e) { return null; }

    var d;
    try { d = ctx.getImageData(0, 0, N, N).data; } catch (e) { return null; }

    var x0 = N, y0 = N, x1 = -1, y1 = -1;
    for (var y = 0; y < N; y++) {
      for (var x = 0; x < N; x++) {
        var p = (y * N + x) * 4;
        if ((d[p] + d[p + 1] + d[p + 2]) / 3 < TROSKEL) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return null;

    return {
      x0: Math.max(0, (x0 - ox) / rw),
      y0: Math.max(0, (y0 - oy) / rh),
      x1: Math.min(1, (x1 + 1 - ox) / rw),
      y1: Math.min(1, (y1 + 1 - oy) / rh)
    };
  }

  function applicera(img, bb) {
    // Rutan måste mätas utan transform, annars växer den för varje omräkning
    img.style.transform = 'none';

    var box = img.getBoundingClientRect();
    var W = box.width, H = box.height;
    if (!W || !H) return;

    var w = img.naturalWidth, h = img.naturalHeight;
    var fit = getComputedStyle(img).objectFit;
    var s = (fit === 'cover') ? Math.max(W / w, H / h) : Math.min(W / w, H / h);
    var rw = w * s, rh = h * s;
    var ox = (W - rw) / 2, oy = (H - rh) / 2;

    var sx = ox + bb.x0 * rw;
    var sy = oy + bb.y0 * rh;
    var sw = (bb.x1 - bb.x0) * rw;
    var sh = (bb.y1 - bb.y0) * rh;
    if (sw <= 0 || sh <= 0) return;

    if ((sw * sh) / (W * H) > FYLLD) return;

    var kHel = Math.min(MAL * W / sw, MAL * H / sh);
    var kFyll = Math.max(MAL * W / sw, MAL * H / sh);
    var k = Math.min(Math.max(kHel, Math.min(kFyll, kHel * EXTRA)), TAK);
    if (k < 1.08) return;

    var cx = sx + sw / 2;
    var cy = sy + sh / 2;

    img.style.transformOrigin = cx + 'px ' + cy + 'px';
    img.style.transform =
      'translate(' + (W / 2 - cx).toFixed(2) + 'px, ' + (H / 2 - cy).toFixed(2) + 'px) ' +
      'scale(' + k.toFixed(3) + ')';

    var p = img.parentElement;
    if (p && getComputedStyle(p).overflow === 'visible') p.style.overflow = 'hidden';
  }

  function aktuell(img) { return img.currentSrc || img.getAttribute('src') || ''; }

  function behandla(img) {
    if (!img || img.dataset.twTrimSkip === '1') return;
    if (!img.closest(BEHALLARE)) return;
    if (img.closest(ALDRIG)) return;

    // Nollställ före mätning, annars mäts den redan zoomade rutan
    if (img.dataset.twTrimSrc) img.style.transform = 'none';

    var box = img.getBoundingClientRect();
    if (box.width > MAXRUTA || box.height > MAXRUTA) return;
    if (box.width < 16 || box.height < 16) return;
    if (img.naturalWidth < MINFIL || img.naturalHeight < MINFIL) return;

    var src = aktuell(img);
    if (!src) return;

    var bb = lasCache(src);
    if (bb === null) {
      bb = matMotiv(img);
      if (!bb) { img.dataset.twTrimSkip = '1'; return; }
      skrivCache(src, bb);
    }

    img.dataset.twTrimSrc = src;
    applicera(img, bb);
  }

  function samla() {
    return Array.prototype.slice.call(document.querySelectorAll(BILDVAL));
  }

  function kor() {
    samla().forEach(function (img) {
      if (img.complete && img.naturalWidth) {
        behandla(img);
      } else {
        img.addEventListener('load', function () { behandla(img); }, { once: true });
      }
    });
  }

  function schemalagg(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 800 });
    else setTimeout(fn, 120);
  }

  function start() {
    schemalagg(kor);

    // Variantbyten och karuseller byter ut bilder i efterhand
    if (window.MutationObserver) {
      var vantar = false;
      new MutationObserver(function () {
        if (vantar) return;
        vantar = true;
        schemalagg(function () { vantar = false; kor(); });
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }

    // Transformen är räknad mot rutans storlek och måste räknas om vid resize
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        samla().forEach(function (img) {
          if (img.dataset.twTrimSrc) {
            var bb = lasCache(img.dataset.twTrimSrc);
            if (bb) applicera(img, bb);
          }
        });
      }, 180);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
